"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 * Schema for tracking time spend in a Slide, associated with a slideProgressId
 * @param {ObjectId} objectIdType ObjectId type from mongoose package
 * @returns Array with Collection name and defined Schema
 */
var SlideTimeStamp = function SlideTimeStamp(objectIdType) {
  if (!objectIdType) {
    throw new Error('objectIdType must be provided');
  }
  return ['SlideTimeStamp', {
    slideProgressId: {
      type: objectIdType,
      ref: 'Slide',
      required: true
    },
    timestamp: Date,
    lastActive: Date,
    // Defines if timestamp was the start or restart of intervals
    // e.g., user began pinging, or went inactive and came back
    isStart: Boolean,
    eventType: String
  }];
};
var _default = SlideTimeStamp;
exports["default"] = _default;